import { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import { flushSignupTracking } from './lib/analytics';
import LandingPage from './routes/LandingPage';
import ComparePage from './routes/ComparePage';
import FAQPage from './routes/FAQPage';
import SupportPage from './routes/SupportPage';
import AboutPage from './routes/AboutPage';
import ExtensionPage from './routes/ExtensionPage';
import LoginPage from './routes/LoginPage';
import RegisterPage from './routes/RegisterPage';
import GatekeeperPage from './routes/GatekeeperPage';
import ForgotPage from './routes/ForgotPage';
import MagicSentPage from './routes/MagicSentPage';
import DashboardPage from './routes/DashboardPage';
import AnalyticsPage from './routes/AnalyticsPage';
import MembersPage from './routes/MembersPage';
import SettingsPage from './routes/SettingsPage';
import OnboardingPage from './routes/OnboardingPage';
import DemoPage from './routes/DemoPage';
import AdminStatsPage from './routes/admin/AdminStatsPage';
import AdminWorkspacesPage from './routes/admin/AdminWorkspacesPage';
import AdminWorkspaceDetailPage from './routes/admin/AdminWorkspaceDetailPage';
import AdminUsersPage from './routes/admin/AdminUsersPage';
import AdminUserDetailPage from './routes/admin/AdminUserDetailPage';
import AdminLinksPage from './routes/admin/AdminLinksPage';
import AdminEmailsPage from './routes/admin/AdminEmailsPage';
import AdminEmailTemplateEditPage from './routes/admin/AdminEmailTemplateEditPage';

export default function App() {
  // Catch the 'just signed up' marker that every signup path leaves in
  // sessionStorage right before redirecting into the SPA — covers email
  // verification, magic-link, OAuth, and the direct register response. Fires
  // once per browser session.
  useEffect(() => {
    flushSignupTracking();
  }, []);

  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/compare" element={<ComparePage />} />
        <Route path="/faq" element={<FAQPage />} />
        <Route path="/support" element={<SupportPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/extension" element={<ExtensionPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/gatekeeper" element={<GatekeeperPage />} />
        <Route path="/forgot" element={<ForgotPage />} />
        <Route path="/magic-sent" element={<MagicSentPage />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/dashboard/stats" element={<AnalyticsPage />} />
        <Route path="/dashboard/members" element={<MembersPage />} />
        <Route path="/dashboard/settings" element={<SettingsPage />} />
        <Route path="/onboarding" element={<OnboardingPage />} />
        <Route path="/onboarding/:stepId" element={<OnboardingPage />} />
        <Route path="/demo" element={<DemoPage />} />
        <Route path="/admin" element={<AdminStatsPage />} />
        <Route path="/admin/workspaces" element={<AdminWorkspacesPage />} />
        <Route path="/admin/workspaces/:id" element={<AdminWorkspaceDetailPage />} />
        <Route path="/admin/users" element={<AdminUsersPage />} />
        <Route path="/admin/users/:id" element={<AdminUserDetailPage />} />
        <Route path="/admin/links" element={<AdminLinksPage />} />
        <Route path="/admin/emails" element={<AdminEmailsPage />} />
        <Route path="/admin/emails/new" element={<AdminEmailTemplateEditPage />} />
        <Route path="/admin/emails/:id" element={<AdminEmailTemplateEditPage />} />
        <Route path="*" element={<LandingPage />} />
      </Routes>
    </>
  );
}
